/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'WorkRecordDispute',dictionary:{"de":{"references":{"workRecord":"Arbeitserfassung","worker":"Mitarbeiter"},"remark":"Anmerkung","isResolved":"Aufgelöst"}}})
import { Login } from './Login';
import { WorkRecord } from './WorkRecord';
import { Worker } from './Worker';

export class WorkRecordDispute extends _BaseModel {
	
	static toString() {
		return 'WorkRecordDispute'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkRecordDispute', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecordDispute', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecordDispute', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkRecordDispute', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkRecordDispute', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkRecordDispute', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecordDispute'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkRecordDispute) || _BaseModel.t('rules.reference', {modelName:'WorkRecordDispute', path:'meta.currentDocument'}) ],
				model: WorkRecordDispute,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkRecordDispute', path:'meta.revisions'}) ],
				model: WorkRecordDispute,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	workRecord:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecord'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecordDispute', path:'references.workRecord'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkRecord) || _BaseModel.t('rules.reference', {modelName:'WorkRecordDispute', path:'references.workRecord'}) ],
				model: WorkRecord,
				returnObject: true,
},
    
	},
	
					
	worker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecordDispute', path:'references.worker'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'WorkRecordDispute', path:'references.worker'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
},
				
	isResolved:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.isResolved'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkRecordDispute', path:'isResolved'}) ],
},
    
	},
	
				
	remark:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute.remark'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WorkRecordDispute', path:'remark'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkRecordDispute._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, isResolved=false, remark='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.isResolved=isResolved;
		this.remark=remark;
		this._id=_id;
	}

	static create(data) {
		return new WorkRecordDispute(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof WorkRecordDispute || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : WorkRecordDispute.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof WorkRecordDispute ? item : WorkRecordDispute.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({workRecord=undefined, worker=undefined, }={}){
		this.workRecord= (workRecord instanceof WorkRecord || typeof workRecord === 'string' || !workRecord) ? workRecord : WorkRecord.create(workRecord);
		this.worker= (worker instanceof Worker || typeof worker === 'string' || !worker) ? worker : Worker.create(worker);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}
